module.exports = __webpack_public_path__ + "static/media/galerija_2019 (44).ba035a6f.jpg";